import { render, staticRenderFns } from "./plan2229.vue?vue&type=template&id=7c4bcc44&scoped=true"
import script from "./plan2229.vue?vue&type=script&lang=js"
export * from "./plan2229.vue?vue&type=script&lang=js"
import style0 from "./plan2229.vue?vue&type=style&index=0&id=7c4bcc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4bcc44",
  null
  
)

export default component.exports